<div class="bg-white rounded-lg px-10 py-7 lg:w-120.25">
  <h2 class="font-bold text-2xl mb-2">Property Detail</h2>
  <app-section-lock-alert [section]="section" />
  <form
    (ngSubmit)="submitForm()"
    class="flex flex-col gap-y-4 mt-6"
    [formGroup]="estateForm"
    [appSectionLock]="section">
    <div>
      <app-ccs-select
        placeholder="Select a Property Type"
        [options]="propertyTypes"
        [formControlName]="estateFormEnum.TYPE_OF_PROPERTY"
        [label]="estateCommonFormControlNames[estateFormEnum.TYPE_OF_PROPERTY]"
        displayKey="label"
        valueKey="value" />
    </div>
    <div>
      <app-ccs-input-money
        placeholder="Enter property value"
        [formControlName]="estateFormEnum.VALUE"
        [label]="estateCommonFormControlNames[estateFormEnum.VALUE]" />
    </div>
    <div>
      <app-ccs-input
        [label]="descriptionLabel"
        [formControlName]="estateFormEnum.DESCRIPTION"
        [placeholder]="
          isRealProperty ? ' Input an address' : 'Input a description'
        " />
    </div>

    @if (isRealProperty) {
      <div>
        <app-ccs-select
          placeholder="Select an option"
          [options]="propertyTypeDetails"
          [formControlName]="estateFormEnum.PROPERTY_TYPE_DETAIL"
          [label]="
            estateRealPropertyFormControlNames[
              estateFormEnum.PROPERTY_TYPE_DETAIL
            ]
          "
          displayKey="label"
          valueKey="value" />
      </div>
    }
  </form>

  <div class="flex justify-end gap-8 mt-11">
    <ui-button
      type="button"
      appCloseModal
      [outline]="true"
      size="sm"
      class="w-full">
      Close
    </ui-button>
    <ui-button
      (click)="submitForm()"
      [disabled]="section | sectionLocked"
      size="sm"
      class="w-full">
      Save
    </ui-button>
  </div>
</div>
